import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { defaultScreenOptions } from '@betty/navigation';
import {
  PaymentMethodVerificationNavigatorProps,
  PaymentMethodVerificationNavigatorParamsList,
} from './PaymentMethodVerificationNavigator.types';
import PaymentMethodVerificationCardsScreen from '../../screens/PaymentMethodVerification/PaymentMethodVerificationCardsScreen/PaymentMethodVerificationCardsScreen';
import PaymentMethodVerificationImagesScreen from '../../screens/PaymentMethodVerification/PaymentMethodVerificationImagesScreen/PaymentMethodVerificationImagesScreen';
import PaymentMethodVerificationSuccessScreen from '../../screens/PaymentMethodVerification/PaymentMethodVerificationSuccessScreen/PaymentMethodVerificationSuccessScreen';
import PaymentMethodVerificationFailureScreen from '../../screens/PaymentMethodVerification/PaymentMethodVerificationFailureScreen/PaymentMethodVerificationFailureScreen';

const PaymentMethodVerification =
  createNativeStackNavigator<PaymentMethodVerificationNavigatorParamsList>();

function PaymentMethodVerificationNavigator({
  route,
}: PaymentMethodVerificationNavigatorProps) {
  const { paymentEntityId } = route?.params || {};
  const initialRouteName = paymentEntityId
    ? 'PaymentMethodVerificationImagesScreen'
    : 'PaymentMethodVerificationCardsScreen';

  return (
    <PaymentMethodVerification.Navigator
      screenOptions={defaultScreenOptions}
      initialRouteName={initialRouteName}
    >
      <PaymentMethodVerification.Screen
        name="PaymentMethodVerificationCardsScreen"
        component={PaymentMethodVerificationCardsScreen}
      />
      <PaymentMethodVerification.Screen
        name="PaymentMethodVerificationImagesScreen"
        component={PaymentMethodVerificationImagesScreen}
        initialParams={route?.params}
      />
      <PaymentMethodVerification.Screen
        name="PaymentMethodVerificationSuccessScreen"
        component={PaymentMethodVerificationSuccessScreen}
      />
      <PaymentMethodVerification.Screen
        name="PaymentMethodVerificationFailureScreen"
        component={PaymentMethodVerificationFailureScreen}
      />
    </PaymentMethodVerification.Navigator>
  );
}

export default PaymentMethodVerificationNavigator;
